import {ApiAttributeParams, CrudSettings, QueryParams} from "../shared/crud/abstractions/base-crud";
import {EnvironmentService} from "../core/environment/environment.service";
import {NastaveniPap, } from "./models/NastaveniPapDto";
import {Injectable} from "@angular/core";
import {BasePagedCrudService} from "../shared/crud/base-crud.service";
import { HttpClient } from "@angular/common/http";
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export class NastaveniPapDataCrud implements CrudSettings<string, NastaveniPap>
{
  baseUrl = '';
  postUrl = '';
  queryParam = undefined;
  createSuffix = undefined;
  editPostfix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = undefined;
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';

  idGetter = (entity: NastaveniPap) => entity.kodUj
  mapper(id: string, from: ApiAttributeParams | undefined): QueryParams {
    const dict = new Map<string, string>();
    dict.set('kodUj', id);
    return { params: dict };
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/StrukturaUcetniJednotky/NastaveniPAP';
  }
}

@Injectable
({
  providedIn: null
})
export class NastaveniPapDataService
  extends BasePagedCrudService<string,NastaveniPap,NastaveniPap,NastaveniPap>
{
  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService)
  {
    super(_http, new NastaveniPapDataCrud(environmentService), dialogService);
  }
}
